import { AfterViewInit, Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
@Component({
  selector: 'app-simular-emprestimo',
  templateUrl: './simular-emprestimo.component.html',
  styleUrls: ['./simular-emprestimo.component.css']
})
export class SimularEmprestimoComponent implements AfterViewInit{

  loading: boolean = true;
  trustedUrl!: SafeResourceUrl;

  constructor(private socialSecurityService: SocialSecurityService, private sanitizer: DomSanitizer) {
    this.socialSecurityService.getLoanUrl().subscribe((res: any) => {
      this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
      this.loading = false;
    });
  }

  ngAfterViewInit(): void {
    const iframe = document.getElementById('iframe-emprestimo') as HTMLIFrameElement;

    iframe.onload = () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDoc) {
        const messageElement = iframeDoc.getElementById('DrnWucMensagem_Conteudo');
        if (messageElement) {
          messageElement.textContent = 'Prezado(a), informamos que o empréstimo está temporariamente suspenso devido à atualização dos saldos e a geração das parcelas do próximo mês. A previsão de reabertura para simulação e contratação a partir das 12h do primeiro dia útil do próximo mês.';
        }
      }
    };

  }

}
